export default __webpack_public_path__ + "static/media/video2.a0aa1ea1.jpg";